const SCRAPER_BASE =
    (import.meta.env.VITE_SCRAPER_ENDPOINT || import.meta.env.NEXT_PUBLIC_SCRAPER_ENDPOINT || '')
        .replace(/\/+$/, '');
const IMAGE_PROXY_BASE = SCRAPER_BASE ? `${SCRAPER_BASE}/img` : '/api/img';
const PSA_CERTIMAGE_RE = /https?:\/\/(?:www\.)?psacard\.com\/certimages\//i;
const PSA_CLOUDFRONT_RE = /https?:\/\/[^/]*cloudfront\.net\/cert\//i;
const OA_IMAGE_RE = /https?:\/\/oa-images\.onlineauthentics\.com\/sm\//i;
// AutographCOA's printed certificate card refuses a checkcoa.com Referer.
const ACOA_CARD_RE = /^https:\/\/www\.autographcoa\.com\/cert\/[A-Za-z0-9]+\/card\.jpg$/i;

export const isDirectPsaImageUrl = (url) =>
    typeof url === 'string' && (PSA_CERTIMAGE_RE.test(url) || PSA_CLOUDFRONT_RE.test(url));

export const shouldProxyImage = (url) => {
    if (typeof url !== 'string') return false;
    return PSA_CERTIMAGE_RE.test(url) || PSA_CLOUDFRONT_RE.test(url) || OA_IMAGE_RE.test(url) || ACOA_CARD_RE.test(url);
};

export const toProxyImageUrl = (url) => {
    if (typeof url !== 'string' || !url) return url;
    // The versioned URL skips browser caches populated before the R2 archive.
    if (isDirectPsaImageUrl(url)) return `${IMAGE_PROXY_BASE}?url=${encodeURIComponent(url)}&v=2`;
    if (!shouldProxyImage(url)) return url;
    return `${IMAGE_PROXY_BASE}?url=${encodeURIComponent(url)}`;
};

// Displaying an image needs no CORS header; reading its pixels does. Anything
// bound for a canvas — the registered verification PNG — therefore goes through the Worker
// proxy even when the <img> path loads it straight from the origin, because
// images.checkcoa.com sends no Access-Control-Allow-Origin.
export const toCorsImageUrl = (url) => {
    if (typeof url !== 'string' || !url) return url;
    if (!/^https?:\/\//i.test(url)) return url;
    if (url.startsWith(IMAGE_PROXY_BASE)) return url;
    return `${IMAGE_PROXY_BASE}?url=${encodeURIComponent(url)}`;
};
